import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-16d0c01b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Mis candidaturas", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_5 = { class: "search-form" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_7 = { class: "table-container" }
const _hoisted_8 = { class: "modern-table" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { key: 2 }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Remoto", -1))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = { key: 2 }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Presencial / Híbrido", -1))
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = { key: 3 }
const _hoisted_20 = { key: 4 }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = ["onClick"]

import useWindowWidth from '@/composables/useWindowWidth';
import DefaultLayout from '@/layouts/DefaultLayout.vue'
import CandidatureService from '@/services/CandidatureService'
import { onMounted, ref, Ref } from 'vue';
import { useAuth } from '@/store/useAuth';
import router from '@/router';
import EmployInterface from '@/interfaces/EmployInterface';
import main from '@/data/main.js';

export default /*#__PURE__*/_defineComponent({
  __name: 'CandidatureView',
  setup(__props) {

const candidatureService = new CandidatureService()
const employs: Ref<any> = ref([])
const filteredEmploys:Ref<any> = ref([])
const loading = ref(false)
const search = ref('')
const store = useAuth()
const { windowWidth } = useWindowWidth()
const tableSmall = ref(850);
const gotoEmploy = (id: number | undefined) => {
    router.push({ name: 'job-detail', params: { id: id } })
}
const gotoPracticum = (id: number | undefined) => {
    router.push({ name: 'project-detail', params: { id: id } })
}

onMounted(async () => {
    if (!store.token) {
        return
    }
    loading.value = true
    employs.value = await candidatureService.ListAllUserCandidatures(store.token)
    filteredEmploys.value = employs.value
    loading.value = false
})

const handleSearch = () => {
    loading.value = true;
    filteredEmploys.value = employs.value.filter((item:any) => {
        return item.employ?.name && item.employ.name.toLowerCase().includes(search.value.toLowerCase());
    });
    loading.value = false;
};

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createBlock(DefaultLayout, null, {
    default: _withCtx(() => [
      (loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_v_icon, {
              name: "ri-loader-2-fill",
              animation: "spin",
              class: "icon"
            })
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _hoisted_3,
            _hoisted_4,
            _createElementVNode("form", _hoisted_5, [
              _createVNode(_component_v_icon, { name: "fa-filter" }),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((search).value = $event)),
                placeholder: "Filtrar por puesto",
                onKeyup: handleSearch,
                class: "input-job"
              }, null, 544), [
                [_vModelText, search.value]
              ])
            ]),
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("table", _hoisted_8, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", null, _toDisplayString(_unref(main).TH_1_CANDIDATURE), 1),
                    (_unref(windowWidth) > tableSmall.value)
                      ? (_openBlock(), _createElementBlock("th", _hoisted_9, _toDisplayString(_unref(main).TH_2_CANDIDATURE), 1))
                      : _createCommentVNode("", true),
                    (_unref(windowWidth) > tableSmall.value)
                      ? (_openBlock(), _createElementBlock("th", _hoisted_10, _toDisplayString(_unref(main).TH_3_CANDIDATURE), 1))
                      : _createCommentVNode("", true),
                    (_unref(windowWidth) > tableSmall.value)
                      ? (_openBlock(), _createElementBlock("th", _hoisted_11, _toDisplayString(_unref(main).TH_4_CANDIDATURE), 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("th", null, _toDisplayString(_unref(main).TH_5_CANDIDATURE), 1),
                    _createElementVNode("th", null, _toDisplayString(_unref(main).TH_6_CANDIDATURE), 1)
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredEmploys.value, (employ) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: employ.id
                    }, [
                      _createElementVNode("td", null, _toDisplayString(employ?.employ?.name), 1),
                      (_unref(windowWidth) > tableSmall.value)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_12, _toDisplayString(employ?.employ?.location?.country?.name) + " (" + _toDisplayString(employ?.employ?.location?.name) + ") ", 1))
                        : _createCommentVNode("", true),
                      (_unref(windowWidth) > tableSmall.value && employ?.employ?.is_remote)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_13, _hoisted_15))
                        : _createCommentVNode("", true),
                      (_unref(windowWidth) > tableSmall.value && !employ?.employ?.is_remote)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_16, _hoisted_18))
                        : _createCommentVNode("", true),
                      (_unref(windowWidth) > tableSmall.value && employ.employ?.is_practicum == 0)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_19, _toDisplayString(employ?.employ?.salary_min_amount?.toLocaleString()) + "€ - " + _toDisplayString(employ?.employ?.salary_max_amount?.toLocaleString()) + "€", 1))
                        : (_unref(windowWidth) > tableSmall.value && employ?.employ?.is_practicum != 0)
                          ? (_openBlock(), _createElementBlock("td", _hoisted_20, "Prácticas"))
                          : _createCommentVNode("", true),
                      _createElementVNode("td", null, _toDisplayString(employ?.employ?.status?.description), 1),
                      (employ?.employ?.is_practicum == 0)
                        ? (_openBlock(), _createElementBlock("td", {
                            key: 5,
                            onClick: ($event: any) => (gotoEmploy(employ?.employ?.id)),
                            style: {"cursor":"pointer"}
                          }, [
                            _createVNode(_component_v_icon, {
                              name: "md-fileopen-round",
                              class: "ver",
                              fill: _unref(main).SECONDARY_COLOR,
                              scale: "2"
                            }, null, 8, ["fill"])
                          ], 8, _hoisted_21))
                        : (_openBlock(), _createElementBlock("td", {
                            key: 6,
                            onClick: ($event: any) => (gotoPracticum(employ?.employ?.id)),
                            style: {"cursor":"pointer"}
                          }, [
                            _createVNode(_component_v_icon, {
                              name: "md-fileopen-round",
                              class: "ver",
                              fill: _unref(main).SECONDARY_COLOR,
                              scale: "2"
                            }, null, 8, ["fill"])
                          ], 8, _hoisted_22))
                    ]))
                  }), 128))
                ])
              ])
            ])
          ]))
    ]),
    _: 1
  }))
}
}

})